import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import en from './en';

export const LANGUAGE_STORAGE_KEY = 'customercare_language';
export const SUPPORTED_LANGUAGES = ['fr', 'en'];
/** Langue par défaut : l'anglais. Les textes d'origine (clés) sont en français, d'où le repli `fr` ci-dessous. */
export const DEFAULT_LANGUAGE = 'en';
const SOURCE_LANGUAGE = 'fr';

/** Langue mémorisée si elle est supportée, sinon la langue par défaut (anglais). */
export const getStoredLanguage = () => {
    try {
        const stored = localStorage.getItem(LANGUAGE_STORAGE_KEY);
        return SUPPORTED_LANGUAGES.includes(stored) ? stored : DEFAULT_LANGUAGE;
    } catch (e) {
        return DEFAULT_LANGUAGE;
    }
};

/**
 * Les textes d'origine sont en français et servent de clés : `t('Tableau de bord')`.
 * Le français renvoie la clé telle quelle ; l'anglais est dans `en.js`. Un texte sans traduction
 * s'affiche donc en français (repli), jamais comme une clé technique.
 */
i18n.use(initReactI18next).init({
    resources: {
        fr: { translation: {} },
        en: { translation: en },
    },
    lng: getStoredLanguage(),
    fallbackLng: SOURCE_LANGUAGE,
    keySeparator: false,
    nsSeparator: false,
    returnEmptyString: false,
    interpolation: { escapeValue: false },
    react: { useSuspense: false },
});

const applyLanguage = (language) => {
    try {
        localStorage.setItem(LANGUAGE_STORAGE_KEY, language);
    } catch (e) {
        /* stockage indisponible : la langue reste valable pour la session */
    }
    if (typeof document !== 'undefined') {
        document.documentElement.lang = language;
    }
};

i18n.on('languageChanged', applyLanguage);
applyLanguage(i18n.language);

export default i18n;
